import { Button, Stack } from '@common-components';
import { FormMode } from 'enums';
import { messages } from 'i18n';
import SplitButton from 'components/SplitButton';

interface FlowBinderFooterProps {
  isSubmitting: boolean;
  onSave: (asDocx: boolean) => void;
  mode: FormMode;
  onClose: () => void;
  isDirectPlacement: boolean;
}

export default function FlowBinderFooter({
  isSubmitting,
  onSave,
  mode,
  onClose,
  isDirectPlacement,
}: FlowBinderFooterProps) {
  const getButtonOptions = () => {
    const options = [
      {
        label: messages.buttons.saveBinderPdf,
        onClick: () => onSave(false),
        disabled: isSubmitting,
      },
      {
        label: messages.buttons.saveBinderDocx,
        onClick: () => onSave(true),
        disabled: isSubmitting,
      },
    ];
    return isDirectPlacement ? options.reverse() : options;
  };

  return (
    <Stack direction="row" gap={1} justifyContent="flex-end" alignItems="center" p={2}>
      {mode !== FormMode.view && (
        <>
          <Button variant="outlined" onClick={onClose}>
            {messages.buttons.close}
          </Button>
          <SplitButton config={{ options: getButtonOptions() }} variant="contained" loading={isSubmitting} />
        </>
      )}
    </Stack>
  );
}
